import type {
  AdminDataQualityClaimRequest,
  AdminDataQualityImportResponse,
  AdminDataQualityPreviewRequest,
  WorldcupResearchCoverageQuery,
  WorldcupResearchCoverageResponse,
  WorldcupResearchImportBatchesResponse,
} from '@ballpeek/api/client'
import { authApiClient } from '~/lib/api-client'

const dataQualityClient = authApiClient.api.admin['data-quality']

async function parseJson<T>(response: Response): Promise<T> {
  if (!response.ok) {
    let message = `Request failed with status ${response.status}`
    try {
      const body = await response.json() as {
        message?: string
        error?: { message?: string, issues?: Array<{ message?: string }> }
      }
      message = body.message ?? body.error?.message ?? body.error?.issues?.[0]?.message ?? message
    }
    catch {
      // Keep the status fallback for non-JSON errors.
    }
    throw new Error(message)
  }
  return response.json() as Promise<T>
}

export async function listDataQualityCoverage(query: Partial<WorldcupResearchCoverageQuery> = {}) {
  const response = await dataQualityClient.coverage.$get({
    query,
    header: { Authorization: '' },
  })
  return parseJson<WorldcupResearchCoverageResponse>(response)
}

export async function listDataQualityArchives() {
  const response = await dataQualityClient.archives.$get({
    header: { Authorization: '' },
  })
  return parseJson<WorldcupResearchImportBatchesResponse>(response)
}

export async function previewDataQualityImport(input: AdminDataQualityPreviewRequest) {
  const response = await dataQualityClient.imports.preview.$post({
    json: input,
    header: { Authorization: '' },
  })
  return parseJson<AdminDataQualityImportResponse>(response)
}

export async function executeDataQualityImport(input: AdminDataQualityClaimRequest) {
  const response = await dataQualityClient.imports.execute.$post({
    json: input,
    header: { Authorization: '' },
  })
  return parseJson<AdminDataQualityImportResponse>(response)
}

export async function retryDataQualityImport(input: AdminDataQualityClaimRequest) {
  const response = await dataQualityClient.imports.retry.$post({
    json: input,
    header: { Authorization: '' },
  })
  return parseJson<AdminDataQualityImportResponse>(response)
}

export async function getDataQualityImportStatus(input: AdminDataQualityClaimRequest) {
  const response = await dataQualityClient.imports.status.$post({
    json: input,
    header: { Authorization: '' },
  })
  return parseJson<AdminDataQualityImportResponse>(response)
}
